import { StreamSubscription, StreamPrice } from './../../models/Socket';
import { CccSocketProvider } from './../../providers/ccc-socket/ccc-socket';
import { Coin } from './../../models/Coin';
import { Component, Input } from '@angular/core';
import { Exchange } from '../../models/Exchanges';

/**
 * Generated class for the MarketExchangeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'market-exchange',
  templateUrl: 'market-exchange.html'
})
export class MarketExchangeComponent {
  @Input('exchange') exchange: Exchange;
  @Input('coin') coin: Coin;

  baseCurrencies: string[] = ['wyt'];
  quoteCurrencies: string[];
  pairs: [string,StreamSubscription][] = [];
  subs: StreamSubscription[];
  constructor(private socket: CccSocketProvider) {
    //put logic to only show pairs for this coin
    if(this.coin){

    }
  }

  ngOnInit(){
    let pairs = this.exchange.getPairsForCoin(this.coin);
    let map = this.exchange.getAssociatedPairs(this.coin);
    this.subs = this.getStreamArrays(map);
    this.socket.subscribe(this.subs);
    this.mergePairs(this.subs);
  }

  ngOnDestroy(){
    this.socket.unSubscribe(this.subs);

  }


  round(volume: number){
    return Math.round(volume);
  }

  public getPriceForPair(pair: [string,StreamSubscription]): StreamPrice{
    return this.socket.getPrice(pair[1]);
  }

  private mergePairs(subs: StreamSubscription[]){
    for(let sub of subs){
      this.pairs.push([
        `${sub.from}/${sub.to}`,
        sub
      ]);
    }
  }

  getValClass(pct: string): string{
    if(pct == '0.00%'){
      return '';
    }else if(pct.indexOf('-') == -1){
      return 'val-positive';
    }else{
      return 'val-negative';
    }
  }

  private getStreamArrays(map: any){
    let streams: StreamSubscription[] = [];
    const eName = this.exchange.name;
    const cName = this.coin.Name;
    for(let from of map.from){
      let stream = this.socket.getStreamSubscription(eName, from, cName);
      streams.push(stream);
    }

    for(let to of map.to){
      let stream = this.socket.getStreamSubscription(eName, cName, to);
      streams.push(stream);
    }
    return streams;
  }

}



// WEBPACK FOOTER //
// ./src/components/market-exchange/market-exchange.ts